import { createRootRoute, Link, Outlet, useMatchRoute } from "@tanstack/react-router";
import { Settings } from "lucide-react";

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  const matchRoute = useMatchRoute();
  const isRoomPage = matchRoute({ to: "/room/$roomId", fuzzy: true });
  const isKioskPage = matchRoute({ to: "/kiosk", fuzzy: true });

  if (isRoomPage || isKioskPage) {
    return <Outlet />;
  }

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-card">
        <div className="mx-auto flex h-14 max-w-7xl items-center justify-between px-4">
          <Link to="/" className="flex items-center gap-2 text-lg font-semibold text-primary">
            <img src="/farmless-icon.svg" alt="Farmless" className="h-6 w-6" />
            Farmless Scheduler
          </Link>
          <nav className="flex items-center gap-4">
            <Link
              to="/"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors [&.active]:text-foreground [&.active]:font-medium"
            >
              Rooms
            </Link>
            <Link
              to="/admin"
              className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground transition-colors [&.active]:text-foreground [&.active]:font-medium"
            >
              <Settings className="h-4 w-4" />
              Admin
            </Link>
          </nav>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
    </div>
  );
}
